import { createContext, useContext } from 'react'
import { AccountId } from '../types/types'

export const AccountContext = createContext<AccountId | null>(null)

export const useAccountContext = (): AccountId => {
  const accountId = useContext(AccountContext)

  if (!accountId) {
    throw new Error('AccountContext is not provided')
  }

  return accountId
}